import { Roles } from 'Src/constants/Roles'

export const seniorManagerRoles = [Roles.REGMEN]
export const headGovernanceRoles = [...seniorManagerRoles, Roles.SENIOR_MANAGER, Roles.HEAD_SECTOR]
export const sectorRoles = [...headGovernanceRoles]
export const gosbRoles = [...sectorRoles, Roles.HEAD_GOVERNANCE, Roles.ANALYST, Roles.MANAGER_DS]
export const terBankRoles = [
	...gosbRoles,
	Roles.TERMEN,
	Roles.SBER_MANAGER,
	Roles.MANAGER_DS,
	Roles.TMPP_GR,
]
